import { Serializable, JsonProperty } from "typescript-json-serializer";
import {Flow} from"../../../../base/model/domain/Flow";
import {State} from"./State";
import {Action} from"../../../../base/model/domain/Action";
@Serializable()
export class StateInstance {
    @JsonProperty()
    _id: string;

    @JsonProperty()
    createdDate:number;
    
    @JsonProperty()
    createdBy:string;

    @JsonProperty()
    modifiedDate:number;

    @JsonProperty()
    entityId:string;
    
    @JsonProperty()
    step:number;

    @JsonProperty()
    name: string;

    @JsonProperty({type:Flow})
    flow:Flow;

    @JsonProperty({type:State})
    state:State;

    @JsonProperty({type:Action})
    action:Action;

    @JsonProperty()
    branchPriority:number;

    @JsonProperty()
    remark?:string;
}